//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { ContentTypeGroup, Language, ContentType } from '@constants'

const EditorUserLevels = Object.freeze([3, 4, 8])

const CREATE_USER_SHARE = gql`
  mutation ($data: CreateUserShareInput) {
    createUserShare(data: $data) {
      id
    }
  }
`

export default {
  scrollToTop: true,
  data() {
    return {
      access: true,
      article: null,
      related: [],
      loadedImg: false,
      brokenImg: false,
      showPlaceholder: true,
      productPrice: null,
      needToRegister: false,
      needToSubscribe: false,
      showSingleLogin: false,
      waitingForPin: false,
      confirmationEmail: null,
      password: null,
      showLogin: false,
      showForgotPassword: false,
      isDownloading: false,
      ContentType,
      startDownload: false,
      externalId: null,
      isShowingCompleteAccount: false,
      Language
    }
  },
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    this.$nuxt.$on('accesscontrol', (val) => {
      this.setBreadcrumb({
        isShow: false
      })
      this.$nuxt.$emit('topbanner', {
        isShow: false
      })
      switch (val) {
        case 'subscribe':
          this.needToSubscribe = true
          break
        case 'register':
          this.needToRegister = true
          break
        case 'singlelogin':
          this.showSingleLogin = true
          break
      }
    })

    this.$nuxt.$on('on-auth-change', async () => {
      await this.refresh(true)
    })

    this.$nuxt.$on('startDownload', () => {
      this.startDownload = true
    })

    this.externalId = this.queryId

    if (isNaN(this.externalId)) {
      this.externalId = await this.getExternalIdFromSlug()
    }

    await this.refresh(true)
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  head() {
    return {
      title: this.article ? `${this.article?.title} - Telecompaper` : 'Telecompaper',
      meta: [
        { httpEequiv: 'content-language', content: this.article?.language?.locale ?? 'en' },
        {
          hid: 'title',
          name: 'title',
          property: 'title',
          content: this.article ? `${this.article?.title} - Telecompaper` : 'Telecompaper'
        },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.article?.title ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', property: 'twitter:card', content: 'summary' },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          property: 'twitter:title',
          content: this.article?.title ?? ''
        },
        {
          hid: 'description',
          name: 'description',
          property: 'description',
          content: this.article?.shortAbstract ?? this.article?.abstract?.substring(0, 512) ?? ''
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.article?.shortAbstract ?? this.article?.abstract?.substring(0, 512) ?? ''
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          property: 'twitter:description',
          content: this.article?.shortAbstract ?? this.article?.abstract?.substring(0, 512) ?? ''
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: this.article && this.article?.imageUrl ? `${this.$config.imgBaseUrl}${this.article?.imageUrl}` : ''
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: this.article && this.article?.imageUrl ? `${this.$config.imgBaseUrl}${this.article?.imageUrl}` : ''
        },
        {
          hid: 'url',
          name: 'url',
          property: 'url',
          content: this.canonical
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: this.canonical
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          property: 'twitter:url',
          content: this.canonical
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.canonical
        }
      ]
    }
  },
  fetchOnServer: true,
  jsonld() {
    let jsonld = {}
    const dateModified = {}
    const author = {}
    if (this.article) {
      if (this.updates && this.updates.length > 0) {
        dateModified.dateModified = this.$dayjs(this.updates[0].changedAt).format()
      }
      if (this.article && this.articleAuthors && this.articleAuthors.length > 0) {
        author.author = this.article.articleAuthors.map((author) => {
          return {
            '@type': 'Person',
            name: `${author.user.firstName} ${author.user.lastName}`,
            url: ''
          }
        })
      }
      jsonld = {
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article'
        },
        headline: this.article.title,
        image: [`${this.$config.imgBaseUrl}${this.article.imageUrl}`],
        datePublished: this.$dayjs(this.article.date).format(),
        ...dateModified,
        ...author,
        publisher: {
          '@type': 'Organization',
          name: 'Telecompaper',
          logo: {
            '@type': 'ImageObject',
            url: `${this.$config.baseURL}/_nuxt/assets/img/svgs/logo.svg`
          }
        },
        isAccessibleForFree: 'False',
        hasPart: {
          '@type': 'WebPageElement',
          isAccessibleForFree: 'False',
          cssSelector: '.paywall'
        }
      }
    }
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      ...jsonld
    }
  },
  computed: {
    filters: sync('filters'),
    cartItems: sync('cart/items'),
    slugParts() {
      const slug = this.$route.path.split('/').filter(Boolean)[1]?.split('--')
      return slug
    },
    pathContentType() {
      return this.$route.path.split('/').filter(Boolean)[0]
    },
    isPartnerContent() {
      if (this.article && this.article.contentType && this.article.contentType.contentTypeGroup)
        return this.article.contentType.contentTypeGroup.id === ContentTypeGroup.PARTNER_CONTENT
      return false
    },
    queryId() {
      return Number.parseInt(this.slugParts[this.slugParts.length - 1])
    },
    titleSlug() {
      return this.slugParts[0]
    },
    contentTypeSlug() {
      return this.$route.path.split('/').filter(Boolean)[0]
    },
    content() {
      return this.article.content || this.article.abstract
    },
    location() {
      const location = this.article.country != null ? this.article.country : this.article.region
      return location
    },
    updates() {
      return this.article.articleUpdates || []
    },
    hasUpdate() {
      return this.updates.length > 0
    },
    latestUpdate() {
      return !this.hasUpdate ? null : this.updates[0].changedAt
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    isOld() {
      if (!this.article) return false
      return this.$dayjs(this.article.date).add(1, 'year') < new Date()
    },
    account() {
      return this.$store.get('user/user') || null
    },
    editorUserLevels() {
      if (!this.account || !this.account.userLevels) return []
      return this.account.userLevels.filter((x) => EditorUserLevels.includes(x.levelId))
    },
    canonical() {
      return (
        this.$config.baseURL +
        (this.article
          ? `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${this.article.externalId}`
          : `/${this.pathContentType}/${this.titleSlug}--${this.externalId}`)
      )
    }
  },
  watch: {
    languageId() {
      if (this.showPlaceholder === true || !this.article || this.languageId === this.article?.languageId) return
      this.$router.replace({ path: '/' })
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('on-auth-change')
    this.$nuxt.$off('accesscontrol')
    this.$nuxt.$off('startDownload')
    this.$nuxt.$emit('topbanner', {
      isShow: true
    })

    // Clean up Flourish so it works correctly when navigating to another route
    if (typeof window !== 'undefined') {
      window.FlourishLoaded = null
    }
  },
  beforeMount() {
    this.setFilters({})
  },
  mounted() {
    this.showLogin = false
  },
  methods: {
    async refresh(purge = false) {
      this.showPlaceholder = true
      this.article = null
      this.needToSubscribe = false
      this.needToRegister = false

      this.$nuxt.$emit('topbanner', {
        isShow: true
      })

      const ARTICLE = gql`
        query GetArticle(
          $where: ArticleFilterInput
          $whereEdition: ArticleEditionFilterInput
          $whereCountry: ArticleCountryFilterInput
          $whereRegion: ArticleRegionFilterInput
          $whereCompany: ArticleCompanyFilterInput
          $whereAuthor: ArticleAuthorFilterInput
          $whereTag: ArticleTagFilterInput
          $whereUpdate: ArticleUpdateFilterInput
          $whereRelation: ArticleRelationFilterInput
          $whereProductPrice: ProductPriceFilterInput
        ) {
          article(where: $where) {
            id
            externalId
            date
            title
            slug
            abstract
            shortAbstract
            imageUrl
            redirectUrl
            content
            contentAfter
            filename
            isFree
            languageId
            language {
              locale
            }
            contentSource {
              id
              name
              website
            }
            edition {
              id
              name
            }
            contentType {
              id
              name
              colour
              contentTypeGroup {
                id
                name
              }
            }
            country {
              id
              name
            }
            region {
              id
              name
            }
          }
          articleEditions(where: $whereEdition) {
            nodes {
              edition {
                id
                name
                contentCollectionEditions(order: { contentCollection: { id: ASC } }) {
                  contentCollection {
                    id
                    slug
                    name
                  }
                }
              }
            }
          }
          articleCountries(where: $whereCountry, order: { country: { name: ASC } }) {
            nodes {
              country {
                id
                name
              }
            }
          }
          articleRegions(where: $whereRegion, order: { region: { name: ASC } }) {
            nodes {
              region {
                id
                name
              }
            }
          }
          articleCompanies(where: $whereCompany) {
            nodes {
              company {
                id
                name
              }
            }
          }
          articleAuthors(where: $whereAuthor) {
            nodes {
              user {
                id
                firstName
                lastName
              }
            }
          }
          articleTags(where: $whereTag) {
            nodes {
              tag {
                id
                name
                text
              }
            }
          }
          articleUpdates(where: $whereUpdate, order: [{ changedAt: DESC }]) {
            nodes {
              id
              changeText
              changedAt
            }
          }
          articleRelations(where: $whereRelation, order: [{ relatedArticle: { date: DESC } }]) {
            nodes {
              relatedArticle {
                id
                externalId
                date
                title
                slug
                abstract
                imageUrl
                redirectUrl
                contentType {
                  id
                  name
                  colour
                  contentTypeGroup {
                    id
                    name
                  }
                }
                edition {
                  id
                  name
                }
                country {
                  id
                  name
                }
                region {
                  id
                  name
                }
              }
            }
          }
          articleProductPrices(where: $whereProductPrice, order: [{ price: ASC }]) {
            nodes {
              id
              price
              license
              externalId
            }
          }
        }
      `

      let doingRedirect = false

      try {
        let where = {
          article: {
            externalId: {
              eq: this.externalId
            }
          }
        }

        let { data } = await this.$apollo.query({
          query: ARTICLE,
          variables: {
            where: {
              externalId: {
                eq: this.externalId
              }
            },
            whereEdition: where,
            whereCountry: where,
            whereRegion: where,
            whereCompany: where,
            whereAuthor: where,
            whereTag: where,
            whereUpdate: where,
            whereRelation: where,
            whereProductPrice: where
          },
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        if (data.article === null) {
          // It may have been deleted and redirected, check
          const redirectTo = await this.getExternalIdRedirectFromDeleted()
          if (redirectTo) {
            this.externalId = redirectTo
            where = {
              article: {
                externalId: {
                  eq: this.externalId
                }
              }
            }
            const result = await this.$apollo.query({
              query: ARTICLE,
              variables: {
                where: {
                  externalId: {
                    eq: this.externalId
                  }
                },
                whereEdition: where,
                whereCountry: where,
                whereRegion: where,
                whereCompany: where,
                whereAuthor: where,
                whereTag: where,
                whereUpdate: where,
                whereRelation: where,
                whereProductPrice: where
              },
              fetchPolicy: purge ? 'network-only' : 'cache-first'
            })
            data = result.data
          }
        }

        if (!data.article) {
          this.$router.push({
            path: `/?utm_source=-&utm_medium=-&utm_campaign=-&utm_content=ArticleNotAvailable`
          })
          return
        }

        this.article = data.article
        this.article.articleEditions = data.articleEditions.nodes
        this.article.articleCountries = data.articleCountries.nodes
        this.article.articleRegions = data.articleRegions.nodes
        this.article.articleCompanies = data.articleCompanies.nodes
        this.article.articleAuthors = data.articleAuthors.nodes
        this.article.articleTags = data.articleTags.nodes
        this.article.articleUpdates = data.articleUpdates.nodes
        this.article.articleRelations = data.articleRelations.nodes
        this.article.productPrices = data.articleProductPrices.nodes
        if (typeof window !== 'undefined' && this.article.redirectUrl) {
          doingRedirect = true
          window.location.href = this.article.redirectUrl
          return
        }

        if (
          this.article.slug !== this.titleSlug ||
          this.getContentTypeUrlName(this.article.contentType) !== this.contentTypeSlug ||
          this.queryId !== this.article.externalId
        ) {
          if (data.article.language.locale !== this.language) {
            this.setLanguage(data.article.language)
            await this.refresh(true)
            return
          }

          this.$router.push({
            path: `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${this.externalId}`
          })
        }

        if (data.article.language.locale !== this.language) {
          this.setLanguage(data.article.language)
        }

        this.related = this.article && this.article.articleRelations ? this.article.articleRelations.slice(0, 20) : []
        this.productPrice =
          this.article && this.article.productPrices && this.article.productPrices.length > 0
            ? this.article.productPrices[0]
            : null

        if (this.article && !this.needToRegister && !this.needToSubscribe && !this.showSingleLogin) {
          this.setBreadcrumb({
            isShow: true,
            pageCategory: this.article.edition.name,
            categoryRedirectUrl: `/${this.article.edition.name}`,
            pageTitle: this.article.title
          })
        } else {
          this.setBreadcrumb({
            isShow: false
          })
        }

        if (this.article && this.startDownload) {
          this.download(this.article.id)
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = doingRedirect
      }
    },
    setLanguage(language) {
      this.$root.$i18n.setLocale(language.locale)
      this.$dayjs.locale(language.locale)
      this.$store.set('language/locale', language.locale)
      this.$store.set('language/hasManuallyChanged', false)
      this.$nuxt.$emit('language-change', language)
    },
    async getExternalIdFromSlug() {
      try {
        const { externalId } = await this.$axios.$get(`${this.$config.apiRestUrl}/sync/translateslug/${this.titleSlug}`)
        return externalId
      } catch {
        return null
      }
    },
    async getExternalIdRedirectFromDeleted() {
      try {
        const { externalId } = await this.$axios.$get(
          `${this.$config.apiRestUrl}/sync/checkforredirect/${this.externalId}`
        )
        return externalId
      } catch {
        return null
      }
    },
    getAuthorsNames() {
      const names = []
      this.article.articleAuthors?.forEach((author) => {
        names.push(`${author.user.firstName} ${author.user.lastName}`)
      })
      return names.join(', ')
    },
    async download(id) {
      if (!this.account) {
        this.$nuxt.$emit('toggleRegisterModal', { isDownload: true })
        return
      }

      if (this.account.company == null || this.account.jobFunctionId == null) {
        this.isShowingCompleteAccount = true
        return
      }

      this.isDownloading = true
      try {
        const response = await this.$axios.$get(`${process.env.API_ROOT}/api/download/${id}`, { responseType: 'blob' })

        const url = window.URL.createObjectURL(response)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        // the filename you want
        a.download = this.article.filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$buefy.toast.open({
          message: this.handleError(error),
          type: 'is-danger'
        })
      } finally {
        this.isDownloading = false
        this.startDownload = false
      }
    },
    addToCart() {
      this.$nuxt.$emit('onCartItemAdded', this.productPrice.externalId, null)
    },
    printArticle() {
      this.onShareClick('DOWNLOAD')
      window.print()
    },
    contentTypeNavigate(contentType) {
      this.setFilterOptions({ contentTypeId: contentType.id })
      this.$router.push({ path: '/all' })
    },
    companyNavigate(company) {
      const filters = JSON.parse(JSON.stringify(this.defaultFilters))
      filters.text = company.name

      this.$router.push({
        path: '/search',
        query: { f: encodeURIComponent(window.btoa(JSON.stringify(filters))) }
      })
    },
    regionNavigate(region) {
      this.setFilterOptions({ regionId: region.id })
      this.$router.push({ path: '/all' })
    },
    countryNavigate(country) {
      this.setFilterOptions({ countryId: country.id })
      this.$router.push({ path: '/all' })
    },
    onUserRegistered(result) {
      this.confirmationEmail = result.email
      this.password = result.password
      this.waitingForPin = true
    },
    onLoginClicked() {
      this.showLogin = true
      this.showForgotPassword = false
    },
    onRegisterClicked() {
      this.showLogin = false
    },
    onForgotPasswordClicked() {
      this.showLogin = false
      this.showForgotPassword = true
    },
    onUserConfirmed() {
      this.showLogin = false
      this.needToRegister = false
    },
    onLoginClick() {
      this.showSingleLogin = false
      this.needToRegister = true
      this.showLogin = true
    },
    onCompleteAccountSubmit() {
      this.download(this.article.id)
    },
    async onShareClick(location) {
      if (this.account == null) return

      try {
        await this.$apollo.mutate({
          mutation: CREATE_USER_SHARE,
          variables: { data: { articleId: this.article.id, location } }
        })
      } catch (error) {
        console.error('failed to record user share action', error)
      }
    }
  }
}
